import React, { useContext } from "react";
import { AuthCodeInputProps } from "./AuthCodeInput.props";
import AuthCodeInputComponent from "./AuthCodeInput";
import Label from "../Label";
import globalFormStyles from "../global.formElements.module.scss";
import { FormContext } from "../../Form/Form.context";
import { useController } from "react-hook-form";

const AuthCodeInput: React.FC<AuthCodeInputProps> = (props: AuthCodeInputProps): JSX.Element => {
  const { labelText, id, validate, name, length, allowedCharacters, onBlur, onFocus, className } = props;
  const { control } = useContext(FormContext);
  const controller = useController({ name, defaultValue: "", control });

  return (
    <div className={globalFormStyles["form-field-container"]}>
      {labelText && <Label id={id} label={labelText} validate={validate} />}
      <div className={globalFormStyles["field-wrapper"]}>
        <AuthCodeInputComponent
          onChange={controller.field.onChange}
          value={controller.field.value ?? ""}
          length={length}
          allowedCharacters={allowedCharacters}
          onBlur={onBlur}
          onFocus={onFocus}
          className={className}
          id={id}
        />
      </div>
    </div>
  );
};

export default AuthCodeInput;
